module.exports = __webpack_public_path__ + "media/80.70df981e.wav";